import styles from './style.module.scss';
import {
  List,
  Typography,
  Space,
  Divider,
  Row,
  Col,
  Avatar,
  Card,
  Descriptions,
  Badge,
} from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { DownloadOutlined, UserOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import useUserVacancies, { statusColors } from '../useUserVacancies';
import NotificationFormForEdit from '../../../../../components/modules/notificationFormForEdit';
import Helpers from '../../../../../helpers';

const Single = ({}) => {
  const { t } = useTranslation();
  const { id, ...reest } = useParams();
  let [searchParams, setSearchParams] = useSearchParams();

  const {
    singleItem,
    statuses,
    handleApprove,
    updateInProcess,
    handleDownloadPdf,
  } = useUserVacancies(false);

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  return (
    <div>
      <PageHeader title={t('Adesione privacy')} />
      <div className={styles.content}>
        <Descriptions column={1} bordered>
          <Descriptions.Item label={t('Outlet Village')}>
            {singleItem?.outlet_village}
          </Descriptions.Item>
          <Descriptions.Item label={t('Utente')}>
            {singleItem?.user}
          </Descriptions.Item>
          <Descriptions.Item label={t('Stato')}>
            <Badge
              color={statusColors[singleItem?.status]}
              text={statuses[singleItem?.status]}
            />
          </Descriptions.Item>
          <Descriptions.Item label={t('MODULO RICHIESTA ADESIONE')}>
            <Space>
              {singleItem?.file_name && singleItem?.file ? (
                <Button
                  type={'primary-white'}
                  loading={updateInProcess}
                  onClick={() =>
                    handleDownloadPdf(singleItem?.file, singleItem.file_name)
                  }
                >
                  {singleItem.file_name}
                </Button>
              ) : (
                <></>
              )}
            </Space>
          </Descriptions.Item>
        </Descriptions>
        <Divider />
        <NotificationFormForEdit
          loading={updateInProcess}
          handleOnFinish={handleApprove}
          showApprove={!!singleItem.can_approve}
          showReject={!!singleItem.can_reject}
          showToAdim={!!singleItem.can_to_admin}
          showRefuse={!!singleItem.can_refuse}
          paramKey={'type_approve'}
          backCount={1}
        />
      </div>
    </div>
  );
};

export default Single;
